import { useTranslation } from 'react-i18next'
import { Breadcrumb } from '@/ui/components/common/Breadcrumb'
import { BreadcrumbJsonLd } from '@/ui/components/public/BreadcrumbJsonLd'
import { useLocalizedUrl } from '@/application/hooks/useLocalizedUrl'

/**
 * Page header for the public investigators page.
 * Owns the breadcrumb navigation, page title, accent bar and subtitle copy.
 */
export function InvestigatorsHeaderSection() {
  const { t } = useTranslation()
  const pageUrl = useLocalizedUrl('/investigators')

  const breadcrumbItems = [
    { label: t('nav.home'), href: '/' },
    { label: t('investigators.page_title') },
  ]

  return (
    <>
      <BreadcrumbJsonLd items={breadcrumbItems} currentUrl={pageUrl} />
      <Breadcrumb items={breadcrumbItems} />
      <div className="mb-8">
        <h1 className="font-serif text-4xl font-black">{t('investigators.page_title')}</h1>
        <div className="h-1 w-16 bg-primary mt-2" />
        <p className="text-muted-foreground mt-3">{t('investigators.page_subtitle')}</p>
      </div>
    </>
  )
}
